import { useBreakpoint } from "@/hooks/useBreakpoint"
import { CLIENT_LOGO_SLIDES } from "@/pages/website-landing/components/client-logos/clientLogos"
import { Carousel } from "antd"
import { FC } from "react"
import "./LogoSlider.less"

const LogoSlider: FC = () => {
  const { xl, md, sm, xs } = useBreakpoint()

  const logoSliderSettings = {
    infinite: true,
    slidesToShow: xl ? 5 : md ? 5.6 : sm ? 2.4 : xs ? 2.5 : 2,
    slidesToScroll: 1,
    swipeToSlide: true,
    dots: false,
    autoplay: true,
    speed: 8000,
    autoplaySpeed: 0,
    cssEase: "linear",
    pauseOnHover: true,
  }

  return (
    <div className={"logo-slide-wrapper"}>
      <Carousel {...logoSliderSettings}>
        {CLIENT_LOGO_SLIDES.map((logo, index) => (
          <div className={"logo-card"} key={`${logo.name}-${index}`}>
            <div className={"logo-img-wrapper"}>
              <img src={logo.src} alt={logo.name} />
            </div>
          </div>
        ))}
      </Carousel>
    </div>
  )
}

export default LogoSlider
